<template>
    <el-select
        filterable
        clearable
        v-model="selected"
    >
        <el-option v-for="i in list" :key="i" :label="i" :value="i">
            <div class="icontainer">
                <span :class="i"></span>
                <div>{{i}}</div>
            </div>
        </el-option>
    </el-select>
</template>
<style lang="scss" scoped>

.el-select-dropdown__item {
    font-size: 14px;
    padding: 8px 10px;
    position: relative;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #48576a;
    height: 100px!important;
    line-height: 1.5;
    box-sizing: border-box;
    cursor: pointer;
    align-items:center!important;
}
.icontainer{
    display:flex;
    align-items:center;
}
.icontainer span{
    font-size: 65px;
    padding-right: 20px;
}

@font-face {
    font-family: 'covid';
    src:  url('/fonts/covid.eot?j0o9fh');
    src:  url('/fonts//covid.eot?j0o9fh#iefix') format('embedded-opentype'),
      url('/fonts/covid.ttf?j0o9fh') format('truetype'),
      url('/fonts/covid.woff?j0o9fh') format('woff'),
      url('/fonts/covid.svg?j0o9fh#covid') format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: block;
  }
  
  [class^="icon-icon"], [class*=" icon-icon"] {
    /* use !important to prevent issues with browser extensions that change fonts */
    font-family: 'covid' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
  
    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  
  .icon-icon-acc:before {
    content: "\e914";
    color: #e53f40;
  }
  .icon-icon-baby:before {
    content: "\e915";
    color: #e53f40;
  }
  .icon-icon-balance:before {
    content: "\e916";
    color: #e53f40;
  }
  .icon-icon-bike:before {
    content: "\e917";
    color: #e53f40;
  }
  .icon-icon-botiquin:before {
    content: "\e918";
    color: #e53f40;
  }
  .icon-icon-carro:before {
    content: "\e919";
    color: #e53f40;
  }
  .icon-icon-estetoscopio:before {
    content: "\e91a";
    color: #e53f40;
  }
  .icon-icon-fire:before {
    content: "\e91b";
    color: #e53f40;
  }
  .icon-icon-hospital:before {
    content: "\e91c";
    color: #e53f40;
  }
  .icon-icon-hot:before {
    content: "\e91d";
    color: #e53f40;
  }
  .icon-icon-megafono:before {
    content: "\e91e";
    color: #e53f40;
  }
  .icon-icon-nohome:before {
    content: "\e91f";
    color: #e53f40;
  }
  .icon-icon-pen:before {
    content: "\e920";
    color: #e53f40;
  }
  .icon-icon-pig:before {
    content: "\e921";
    color: #e53f40;
  }
  .icon-icon-rain:before {
    content: "\e922";
    color: #e53f40;
  }
  .icon-icon-snow:before {
    content: "\e923";
    color: #e53f40;
  }
  .icon-icon-user-confg:before {
    content: "\e924";
    color: #e53f40;
  }
  .icon-icon-users:before {
    content: "\e925";
    color: #e53f40;
  }
  .icon-icon-vote:before {
    content: "\e926";
    color: #e53f40;
  }
  .icon-icon-abu:before {
    content: "\e927";
    color: #e53f40;
  }
  .icon-huaso:before {
    content: "\e913";
    color: #d0021b;
  }
  .icon-icon-cuarentena:before {
    content: "\e910";
    color: #e53f40;
  }
  .icon-icon-judicial:before {
    content: "\e911";
    color: #e53f40;
  }
  .icon-icon-presencial:before {
    content: "\e912";
    color: #e53f40;
  }
  .icon-icon-sofa:before {
    content: "\e90f";
    color: #e53f40;
  }
  .icon-icon-beneficios:before {
    content: "\e90e";
    color: #e53f40;
  }
  .icon-icon-canasta:before {
    content: "\e90c";
    color: #e53f40;
  }
  .icon-icon-news:before {
    content: "\e90d";
    color: #e53f40;
  }
  .icon-icon-documento:before {
    content: "\e90a";
    color: #e53f40;
  }
  .icon-icon-pyme:before {
    content: "\e90b";
    color: #e53f40;
  }
  .icon-icon-escuela:before {
    content: "\e904";
    color: #e53f40;
  }
  .icon-icon-estudio:before {
    content: "\e905";
    color: #e53f40;
  }
  .icon-icon-migracion:before {
    content: "\e906";
    color: #e53f40;
  }
  .icon-icon-salud:before {
    content: "\e907";
    color: #e53f40;
  }
  .icon-icon-trabajo:before {
    content: "\e908";
    color: #e53f40;
  }
  .icon-icon-viaje:before {
    content: "\e909";
    color: #e53f40;
  }
  .icon-icon-flecha:before {
    content: "\e903";
    color: #e53f40;
  }
  .icon-icon-coronavirus-blanco:before {
    content: "\e902";
    color: #fff;
  }
  .icon-icon-escudo:before {
    content: "\e900";
    color: #e53f40;
  }
  .icon-icon-coronavirus:before {
    content: "\e901";
    color: #e53f40;
  }

</style>
<script>
    import ElSelect from 'element-ui/lib/select';
    import ElOption from 'element-ui/lib/option';

    export default {
        data: function () {
            return{
                selected: this.value,
                list: []
            }
        },
        components: {
            ElSelect,
            ElOption
        },
        props: ['value'],
        watch: {
            value: function (value) {
                this.selected = value;
            },
            selected: function (value) {
                this.$emit('input', value);
            }
        },
        mounted: function () {
            const set = new Set([
            'icon-icon-acc',
            'icon-icon-baby',
            'icon-icon-balance',
            'icon-icon-bike',
            'icon-icon-botiquin',
            'icon-icon-carro',
            'icon-icon-estetoscopio',
            'icon-icon-fire',
            'icon-icon-hospital',
            'icon-icon-hot',
            'icon-icon-megafono',
            'icon-icon-nohome',
            'icon-icon-pen',
            'icon-icon-pig',
            'icon-icon-rain',
            'icon-icon-snow',
            'icon-icon-user-confg',
            'icon-icon-users',
            'icon-icon-vote',
            'icon-icon-abu',
            'icon-icon-cuarentena',
            'icon-icon-judicial',
            'icon-icon-presencial',
            'icon-icon-sofa',
            'icon-icon-beneficios',
            'icon-icon-canasta',
            'icon-icon-news',
            'icon-icon-documento',
            'icon-icon-pyme',
            'icon-icon-escuela',
            'icon-icon-estudio',
            'icon-icon-migracion',
            'icon-icon-salud',
            'icon-icon-trabajo',
            'icon-icon-viaje',
            'icon-icon-flecha',
            'icon-icon-coronavirus-blanco',
            'icon-icon-escudo',
            'icon-icon-coronavirus']);
            this.list = Array.from(set);
        }
    }
</script>